@use "variables" as *;

.videoDiv {
  display: flex;
  justify-content: center;
  margin-bottom: $spacing-m;
}

.image {
  width: 100%;
}

.iosShare {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrAppStore {
  max-width: 300px;
  margin-top: $spacing-l;
  margin-bottom: $spacing-l;
  border-radius: 32px;
}

.appStoreButton {
  align-self: flex-start;
}
